import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class AstronomerHideout4PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.ASTRONOMER_HIDEOUT4;
}

export default AstronomerHideout4PoiTileEntity;
